module.exports = __webpack_public_path__ + "img/ksaq.797c3df.png";